 <style scoped lang="css">
    #login {
        height: 50%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        z-index: 0;
    }
</style>
<template>
    <v-app id="login" class="yoprimary" style="background-color: #00a650">
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4 lg3 xl3 style="text-align: center">
                        <img src="/img/logo_frontend.png" :alt="$t('lang.header.title')" width="" height="120">
                        <v-card class="elevation-1 pa-3">
                            <v-card-text>
                                <div class="layout column align-center">
                                    <h1 class="flex my-4">Đặt Lại Mật Khẩu</h1>
                                </div>
                                <v-form>
                                    <v-text-field append-icon="lock" v-on:keyup.enter="handleSubmit"
                                                  v-validate="'required|min:8'"
                                                  :label="$t('lang.user.newPassword')" type="password"
                                                  v-model="user.password" ref="password"
                                                  name="password"
                                                  key="password"
                                                  :error-messages="errors.first('password')"
                                                  :data-vv-as="$t('lang.user.newPassword')"
                                    ></v-text-field>
                                    <v-text-field append-icon="lock" v-on:keyup.enter="handleSubmit"
                                                  v-validate="'required|confirmed:password'"
                                                  :label="$t('lang.user.retypePassword')" type="password"
                                                  v-model="user.confirmPassword"
                                                  name="confirmPassword"
                                                  key="confirmPassword"
                                                  :error-messages="errors.first('confirmPassword')"
                                                  :data-vv-as="$t('lang.user.retypePassword')"
                                    ></v-text-field>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <!--lang-switcher></lang-switcher-->
                                <div style="text-align: center;width: 100%">
                                    <v-btn class="yoprimary" dark @click="handleSubmit">
                                        {{ $t('lang.common.continue') }}
                                    </v-btn>
                                    <br/>
                                    <v-btn class="primaryColor" flat @click="cancel">{{ $t('lang.common.cancel') }}
                                    </v-btn>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import LangSwitcher from "../components/header/LangSwitcher";
    import {message} from '../services';
    import axios from "axios"

    export default {
        components: {
            LangSwitcher
        },
        data() {
            return {
                userName: '',
                user: {
                    password: '',
                    confirmPassword: '',
                    verify: ''
                },
                submitted: false
            }
        },
        beforeCreate() {
        },
        created() {
            if (this.$route.params.verify) {
                this.user.verify = this.$route.params.verify;
            }
            if (this.$route.params.userName) {
                this.userName = this.$route.params.userName;
            }
        },
        methods: {
            handleSubmit(e) {
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    this.submitted = true;
                    axios.post(process.env.VUE_APP_API_URL + "/user/resetPass", this.user).then(
                        data => {
                            if (data.success) {
                                message.success("Thiết lập mật khẩu mới thành công ");
                                this.login();
                            } else {
                                message.error("Mã xác thực không chính xác");
                            }
                        }
                    )
                });
            },

            cancel: function () {
                this.$router.push("/login");
            },

            login: function () {
                const {dispatch} = this.$store;
                let username = this.userName;
                let password = this.user.password;
                if (username && password) {
                    dispatch('auth/login', {cred: {username, password}, vm: this});
                }

            },

        }
    };
</script>

